import React, { createContext, useState, useEffect, useContext } from "react";
import jwtDecode from "jwt-decode";
import { getUser, clearUserSession } from "./services/userService";
import { getPermisos } from "./services/permisosService";
import { getShortcuts } from "./services/shortcutsService";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [activeUser, setActiveUser] = useState(null); // 'null' means logged out
  const [loading, setLoading] = useState(true);
  const [permisos, setPermisos] = useState(null);
  const [shortcuts, setShortcuts] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  useEffect(async () => {
    setModule(localStorage.getItem("selectedModule"));
    const jwt = localStorage.getItem("token");
    if (!jwt) {
      setLoading(false);
      return;
    }
    const decoded = jwt ? jwtDecode(jwt) : null;
    if (decoded) {
      let user = null;
      try {
        user = await getUser(decoded.user._id);
        if (user.profile) {
          setActiveUser(user);
          getPermisosandShortcuts(user.profile._id);
        } else {
          localStorage.removeItem("token");
        }
      } catch (err) {
        localStorage.removeItem("token");
      } finally {
        setLoading(false);
      }
    }
  }, []);

  const getPermisosandShortcuts = async (profileId) => {
    const permisos = await getPermisos(profileId);
    setPermisos(permisos);
    const shortcuts = await getShortcuts(localStorage.getItem("selectedModule"));
    setShortcuts(shortcuts);
  };

  const loginUser = (userData, token) => {
    setActiveUser(userData);
    getPermisosandShortcuts(userData.profile._id);
    localStorage.setItem("token", token);
  };

  const logoutUser = () => {
    clearUserSession(activeUser._id);
    setActiveUser(null);
    clearModule();
    localStorage.removeItem("token");
    localStorage.removeItem("selectedModule");
  };

  const setModule = async (module) => {
    localStorage.setItem("selectedModule", module);
    const shortcuts = await getShortcuts(module);
    setShortcuts(shortcuts);
    setSelectedModule(module);
  };

  const clearModule = () => {
    setSelectedModule(null);
    setShortcuts([]);
  };

  if (loading) return <></>;
  return (
    <AuthContext.Provider
      value={{ activeUser, permisos, selectedModule, shortcuts, setModule, clearModule, loginUser, logoutUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// 3. Optional: Custom hook for easier access
export const useAuth = () => useContext(AuthContext);
